import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import type FastPhonicsReportingProgressStudentTableRoute from 'teacher-ui-client/reporting/ui-scope/fast-phonics/progress/student/table/route'
import type FastPhonicsReportingProgressReviewStudentsController from 'teacher-ui-client/reporting/ui-scope/fast-phonics/progress/student/table/controller'
import TablesPeaksProgressStudentComponent from 'teacher-ui-client/components/tables/peaks-progress/student'

interface Signature {
  Args: {
    model: ModelFor<FastPhonicsReportingProgressStudentTableRoute>
    controller: FastPhonicsReportingProgressReviewStudentsController
  }
}
export const FpProgressStudentTablePage: TOC<Signature> = <template>
  <TablesPeaksProgressStudentComponent
    @studentLessonData={{@model.studentLessonData}}
    @onSortClick={{@controller.updateSorts}}
    @sortingConfig={{@controller.sortingConfig}}
    @exportable={{true}}
  />
</template>

export default RouteTemplate(FpProgressStudentTablePage)
